import { TransmissionState, Transmission } from './types';
import { Module, MutationTree, ActionTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import _ from 'lodash';
import { PostTransmettreRequest } from '@/services/api/transmission/types';
import { postTransmettreAATComplet, postTransmettreAATPartiel } from '@/services/api/transmission/api';

const namespaced: boolean = true;
/** Variable d'environnement TELECONSULTATION */
declare const TELECONSULTATION: boolean;

export const state: TransmissionState = {
	transmission: new Transmission(),
	error: false,
	loaded: false
};

export const mutations: MutationTree<TransmissionState> = {
	updateTransmission(state: TransmissionState, transmission: Transmission): void {
		state.transmission = transmission;
	},
	updateError(state: TransmissionState, error: boolean): void {
		state.error = error;
	},
	updateLoaded(state: TransmissionState, loaded: boolean): void {
		state.loaded = loaded;
	}
};

export const actions: ActionTree<TransmissionState, RootState> = {
	transmettreAAT(state, postTransmettreRequest: PostTransmettreRequest): Promise<void> {
		const postTransmettreRequestPartial = {
			type: postTransmettreRequest.type,
			motif: postTransmettreRequest.motif,
			duree: postTransmettreRequest.duree,
			sortie:  postTransmettreRequest.sortie,
			precisions: postTransmettreRequest.precisions,
			statutActivite: postTransmettreRequest.statutActivite
		};
		return new Promise((resolve, reject) => {
			if (TELECONSULTATION) {
				return postTransmettreAATComplet(postTransmettreRequest)
					.then((response: any) => {
						const errorCode = _.get(response, 'data.value.errorCode');
						state.commit('updateTransmission', new Transmission(_.get(response, 'data.value')));
						state.commit('updateLoaded', true);
						if ( !_.isEmpty(errorCode) || _.isNil(_.get(response, 'data.value.identifiant'))
							|| _.isNil(_.get(response, 'data.value.dateDepot'))) {
							reject();
						} else {
							resolve();
						}
					})
					.catch((error: any) => {
						state.commit('updateLoaded', true);
						state.commit('updateError', true);
						reject();
					});
			} else {
				return postTransmettreAATPartiel(postTransmettreRequestPartial)
					.then((response: any) => {
						const errorCode = _.get(response, 'data.value.errorCode');
						state.commit('updateTransmission', new Transmission(_.get(response, 'data.value')));
						state.commit('updateLoaded', true);
						if ( !_.isEmpty(errorCode) || _.isNil(_.get(response, 'data.value.identifiant'))
							|| _.isNil(_.get(response, 'data.value.dateDepot'))) {
							reject();
						} else {
							resolve();
						}
					})
					.catch((error: any) => {
						state.commit('updateLoaded', true);
						state.commit('updateError', true);
						reject();
					});
			}
		});
	}
};

export const getters: GetterTree<TransmissionState, RootState> = {
	getTransmission(state) {
		return state.transmission;
	}
};

export const transmission: Module<TransmissionState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};
